import { Divider, Empty } from 'antd';

import { Table } from '@atom/table/table';
import { PaginationCursor } from '@component/pagination/pagination-cursor';
import { LogsFilter } from '@component/tables/log-filter/logs-filter';
import { isExist, isString } from '@util/data/is-exist';

import { eventLogsColumns } from './event-logs.options';
import { useEventLogs } from './use-event-logs.hook';

interface RequestLogsProps {
  isLoading?: boolean;
  currentConsumerId?: string;
}

export const EventLogs = ({ isLoading, currentConsumerId }: RequestLogsProps) => {
  const { data, isLoading: isLoadingLogs, pagination, onNext, onPrevious, onChangeFilter } = useEventLogs();

  return (
    <>
      <LogsFilter onChange={onChangeFilter} />
      <Divider />
      <Table
        columns={eventLogsColumns}
        dataSource={data}
        loading={isLoading || isLoadingLogs}
        rowKey='id'
        footer={
          isExist(pagination)
            ? () => <PaginationCursor pagination={pagination} onNext={onNext} onPrevious={onPrevious} />
            : undefined
        }
        locale={{
          emptyText: (
            <Empty
              description={isString(currentConsumerId) ? 'No logs' : 'Select consumer'}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          ),
        }}
      />
    </>
  );
};
